import React from 'react';
import { StandaloneResetPasswordForm } from '@fiverr-private/identification_marketplace';
import { SimpleFormWrapper } from '../shared/SimpleFormWrapper';
import '../shared/styles/Global.ve.css';
import { useExperiment } from '../../../lib/useExperiment';
import { EXPERIMENTS } from '../../../../configuration/constants';

export const ResetPassword = () => {
  const { group } = useExperiment(EXPERIMENTS.LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP);

  const onSubmit = () => {
    window.location.assign('/');
  };

  return (
    <SimpleFormWrapper>
      <StandaloneResetPasswordForm
        onSubmit={onSubmit}
        mixpanelEnrichment={{
          funnel: 'standard',
          triggerType: 'User Trigger',
        }}
        bigQueryEnrichment={{
          funnel: 'standard',
          reason: 'user_trigger',
        }}
        doubleStepResetPasswordExperimentGroup={group}
      />
    </SimpleFormWrapper>
  );
};
